"use client";

import { classNames } from "./class-names";

export type SegmentedControlProps<T extends string> = Readonly<{
  label: string;
  value: T;
  options: ReadonlyArray<{ value: T; label: string; title?: string }>;
  onChange: (value: T) => void;
}>;

export function SegmentedControl<T extends string>({
  label,
  value,
  options,
  onChange,
}: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="flex w-full items-center gap-1.5"
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            title={option.title ?? option.label}
            onClick={() => onChange(option.value)}
            className={classNames(
              "flex-1 rounded-md border px-3 py-2 text-center text-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
              selected
                ? "border-brand bg-brand-subtle font-semibold text-zinc-950"
                : "border-zinc-200 bg-white font-medium text-zinc-600 hover:border-zinc-300 hover:text-zinc-800",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
